export default __webpack_public_path__ + "static/media/manage-account-banner.b2e4a34e.png";